<template>
  <b-field>
    <b-numberinput v-model="val" controls-position="compact" :controls="false"></b-numberinput>
  </b-field>
</template>

<script>
import SchemaFormElementMixin from '@/mixins/SchemaFormElementMixin'

export default {
  name: 'SchemaFormElementNumber',
  mixins: [SchemaFormElementMixin],
  created() {
    if (this.schema.default && !this.val && !this.value) {
      this.val = this.schema.default
    }
  }
}
</script>
